<section
  id="homeNewsSection"
  aria-labelledby="home-news-section-title"
  class="pb-10 md:pb-36 home-news-section overflow-hidden"
>
  <div class="custom-container">
    <div class="flex items-center justify-between mb-8">
      <h2
        class="section-title"
        id="home-news-section-title"
        [innerHTML]="'home.home_news_title' | translate | safeHtml"
      >
      </h2>
    </div>

    @if (loading()) {
      <mat-spinner mode="indeterminate" value="50"/>
    } @else {
      <app-news-list [newsList]="newsList()"/>
    }
  </div>
</section>
